import { Injectable } from '@angular/core';
import { ProductConfiguration } from '../product-configuration';

@Injectable()
export class ProductConfigurationVirtual extends ProductConfiguration {
    /**
     * Configuration type
     */
    readonly type = 'virtual';
}
